import axios from "../../config/axiosConfig";
import { CREATE_DEBIT_NOTE_BILL_BASE_RETURN, GET_DEBIT_NOTE_BILL_BASE_RETURNS, DEBIT_NOTE_BILL_BASE_RETURN_REQUEST, 
  UPDATE_DEBIT_NOTE_BILL_BASE_RETURN, DELETE_DEBIT_NOTE_BILL_BASE_RETURN, DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE,
  GET_DEBIT_NOTE_BILL_BASE_RETURNS_PAGE, DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_SUCCESS } from "../types";

export const getDebitNoteBillBaseReturnsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST });
      
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Account_Id,Credit_Account_Id,Item_Id'
      };
      return axios.get("/debit-note-bill-base-return/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DEBIT_NOTE_BILL_BASE_RETURNS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};
export const getDebitNoteBillBaseReturns = (include, searchStr, searchCols, limit) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include, search: searchStr, searchCols, limit };
      }
      return axios.get("/debit-note-bill-base-return/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DEBIT_NOTE_BILL_BASE_RETURNS, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getDebitNoteBillBaseReturnByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/debit-note-bill-base-return/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getDebitNoteBillBaseReturnById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST });

      return axios.get(`/debit-note-bill-base-return/get/${id}`).then((response) => {
        dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getValidatedIncrementedVchNoDebitNoteBillBaseReturn = (currentVchNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };

      const response = await axios.get("/debit-note-bill-base-return/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const createDebitNoteBillBaseReturn = (debitNoteBillBaseReturn) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST });
      const newDebitNoteBillBaseReturn = {
        ...debitNoteBillBaseReturn
      };
      return axios.post("/debit-note-bill-base-return/add", newDebitNoteBillBaseReturn,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_DEBIT_NOTE_BILL_BASE_RETURN, payload: response.data });
        } else {
          dispatch({
            type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE,
            error: "Debit Note create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateDebitNoteBillBaseReturn = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST });
      const { auth } = getState();
      return axios.put("/debit-note-bill-base-return/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Company_Id || auth.company?.id,
            finyearId: data.Finyear_Id || auth.finyear?.id,
            customerId: data.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_DEBIT_NOTE_BILL_BASE_RETURN,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE,
            error: "Debit Note update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteDebitNoteBillBaseReturn = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST });
      const { auth } = getState();
      return axios.delete(`/debit-note-bill-base-return/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_DEBIT_NOTE_BILL_BASE_RETURN, id: id });
          const include = ['id', 'Vch_No', 'Date', 'Account_Id', 'Credit_Account_Id', 'Invoice_No', 'Invoice_Date', 'Amount', 'Total_Amount', 'Item_Id', 'Ack_No'].join(',');
          const searchCols = ['Vch_No'].join(',');
          const { inventory: { debitNoteBillBaseReturn: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getDebitNoteBillBaseReturnsWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const generateEInvoiceDebitNoteBillBaseReturn = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST });
      const { auth } = getState();
      
      return axios.get(`/debit-note-bill-base-return/generate-e-invoice/${id}`,{ params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_DEBIT_NOTE_BILL_BASE_RETURN,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.log('generate eway bill error',error);
        dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const cancelEInvoiceDebitNoteBillBaseReturn = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST });
      const { auth } = getState();
      return axios.post(`/debit-note-bill-base-return/cancel-e-invoice/${id}`, data, { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_DEBIT_NOTE_BILL_BASE_RETURN,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteEInvoiceDebitNoteBillBaseReturn = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/debit-note-bill-base-return/delete-e-invoice-bills", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const sendMailDebitNoteBillBaseReturn = (mailData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', mailData.to);
      formData.append('templateId', mailData.templateId);
      formData.append('debitNoteId', mailData.debitNoteId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', mailData.recipientType || 'custom');
      formData.append('moduleName', mailData.moduleName);
      
      // Add PDF attachment if exists
      if (mailData.pdfAttachment) {
        formData.append('attachment', mailData.pdfAttachment, `debit_node_bill_base_return_${mailData.debitNoteId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/debit-note-bill-base-return/mail-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const sendWhatsappDebitNoteBillBaseReturn = (whatsappData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', whatsappData.to);
      formData.append('templateId', whatsappData.templateId);
      formData.append('debitNoteId', whatsappData.debitNoteId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', whatsappData.recipientType || 'custom');
      
      // Add PDF attachment if exists
      if (whatsappData.pdfAttachment) {
        formData.append('attachment', whatsappData.pdfAttachment, `debit_node_bill_base_return_${whatsappData.debitNoteId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/debit-note-bill-base-return/whatsapp-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};